module.exports = __webpack_public_path__ + "static/media/IMG_3843.736d6a26.PNG";